import { render, staticRenderFns } from "./JobFormSection.vue?vue&type=template&id=12dd31be&scoped=true"
import script from "./JobFormSection.vue?vue&type=script&lang=js"
export * from "./JobFormSection.vue?vue&type=script&lang=js"
import style0 from "./JobFormSection.vue?vue&type=style&index=0&id=12dd31be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dd31be",
  null
  
)

export default component.exports